/* eslint-disable react/no-unescaped-entities */
import { FC } from 'react';
import styled from 'styled-components';

import { ApplicationInstructionProps } from 'entities/application/constants/applications/OTVB/OTVBInstructions/OTVBInstructions';
import { MpLink } from 'shared/ui/MpLink';
import { MpOl } from 'shared/ui/MpOl';
import { MpPropertyTitle } from 'shared/ui/MpPropertyTitle';
import { MpText } from 'shared/ui/MpText';
import { MpTextbox } from 'shared/ui/MpTextbox';

const ImgStyled = styled.img`
	margin-top: 16px;
	margin-bottom: 12px;
	margin-left: 0;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: 100%;
	}
	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 450px;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 600px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		margin-left: 46px;
	}
`;

export const ListStyled = styled(MpOl)`
	gap: 12px;
	margin-bottom: 24px;
`;

export const DenvikInstruction: FC<ApplicationInstructionProps> = ({ applicationId }) => (
	<section>
		<MpPropertyTitle style={{ marginBottom: `16px` }}>Установка</MpPropertyTitle>
		<ListStyled>
			<li>
				<MpText>
					Скачивание.
					<br />
					Оформите подписку, а&nbsp;затем скачайте обработку через&nbsp;кнопку «Скачать файл». Файл сохранится
					на&nbsp;вашем компьютере.
				</MpText>
			</li>
			<li>
				<MpText>
					Подготовка к установке.
					<br />
					Откройте 1С и перейдите в пункт меню «Администрирование» — «Печатные формы и обработки».
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-1'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px` }}>
					Проверьте, что стоит галочка на пункте «Дополнительные отчеты и обработки». Если нет – установите
					галочку.
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-2' />
			</li>
			<li>
				<MpText>
					Добавление файла обработки.
					<br />
					Перейдите по ссылке «Дополнительные отчеты и обработки». В открывшемся списке нажимаем «Добавить из
					файла».
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-3'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px` }}>
					Выйдет предупреждение безопасности — нажмите «Продолжить».
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-4'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px` }}>
					Выберите сохраненный файл обмена: DodoIs_ЗагрузкаДанных_Готовая.epf.
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-5' />
			</li>
			<li>
				<MpText>
					Завершение установки.
					<br />
					Выберите в каком пункте меню будет вызываться обработка. Для примера выбран пункт «Продажи».
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-6'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px` }}>
					Укажите пользователей, которым разрешено пользоваться обработкой. Зайдите в&nbsp;«Быстрый доступ»,
					в&nbsp;открывшемся окне перенесите нужных пользователей в&nbsp;правую часть списка и&nbsp;нажмите
					«ОК».
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-7'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px` }}>Нажмите «Записать и закрыть».</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-8'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px` }}>Обработка добавлена.</MpText>
			</li>
		</ListStyled>
		<MpPropertyTitle style={{ marginBottom: `16px` }}>Первый запуск и настройка</MpPropertyTitle>
		<MpText>Обработка обмена будет доступна из&nbsp;пункта меню «Продажи» — «Дополнительные обработки».</MpText>
		<ImgStyled
			src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-9'
			style={{ marginBottom: `24px` }}
		/>
		<MpTextbox>
			Если&nbsp;у&nbsp;вас уже&nbsp;есть&nbsp;база, сразу после&nbsp;настройки нужно выполнить шаги
			по&nbsp;миграции базы под&nbsp;новую обработку. Подробнее шаги расписаны ниже. Обязательно нужно сделать
			это&nbsp;при&nbsp;первом запуске, иначе документы будут создаваться неправильно
		</MpTextbox>
		<ListStyled>
			<li>
				<MpText>
					Запуск обработки.
					<br />
					Выберите обработку «Загрузка данных (Dodo IS)» и&nbsp;нажмите кнопку «Выполнить».
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-10-new' />
			</li>
			<li>
				<MpText style={{ marginBottom: `12px` }}>
					Заполнение настроек.
					<br />
					При первом открытии обработка попросит указать общие настройки. Рекомендуем воспользоваться кнопкой
					«Заполнить сразу все настройки по&nbsp;умолчанию».
				</MpText>
				<MpText style={{ marginLeft: `-16px` }}>
					Нажмите «Заполнить сразу все настройки по умолчанию». Затем проверьте, что все заполненные значения
					корректные.
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction/11' />
			</li>
			<li>
				<MpText>
					Установка обмена с Dodo IS.
					<br />
					Нажмите кнопку «Получить». В открывшемся окне войдите в Dodo IS. Потребуется ваша личная учётная
					запись с ролью «Менеджер Офиса». Обмен данными будет происходить от имени вашей учётки.
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-12-new'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px` }}>
					После&nbsp;авторизации данные начнут загружаться из&nbsp;Dodo IS. Загрузка может происходить почти
					мгновенно, а&nbsp;может занимать 1–2&nbsp;минуты. Всё&nbsp;зависит от&nbsp;мощностей,
					где&nbsp;расположена база 1С и&nbsp;выбранного периода. Если&nbsp;у&nbsp;вас был&nbsp;обмен данными
					с&nbsp;Dodo IS, то&nbsp;сразу переходите к&nbsp;следующим шагам по&nbsp;миграции старой базы.
				</MpText>
			</li>
		</ListStyled>
		<MpPropertyTitle style={{ marginBottom: `16px` }}>Миграция старой базы</MpPropertyTitle>
		<MpText style={{ marginBottom: `24px` }}>
			Если у вас уже работал обмен с Dodo IS, то вам нужно мигрировать 1С базу под новую обработку. Для этого
			необходимо сопоставить номенклатуру, которую использует обработка, с той, которая заведена в вашей базе.
		</MpText>
		<MpTextbox>
			<MpText>
				Миграция может занимать до нескольких часов, в зависимости от расхождений в наименовании номенклатуры.
				Если вы не уверены, что сможете пройти шаги самостоятельно, запросите консультацию. Условия консультаций
				можно найти в разделе <MpLink url={`/${applicationId}#tariffs`} text='«Тарифы»' internal />
			</MpText>
		</MpTextbox>
		<ListStyled>
			<li>
				<MpText>
					Готовность к миграции.
					<br />
					Обработка должна быть запущена и пройдены шаги по{` `}
					<MpLink url={`/${applicationId}#instruction`} text='первоначальной настройке' internal />
				</MpText>
			</li>
			<li>
				<MpText>
					Запуск миграции.
					<br />
					Выберите пункт «Настройки».
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-3-1'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px` }}>В открывшемся окне перейти во вкладку «Номенклатура».</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-3-2'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px` }}>
					Укажите старые реквизиты номенклатуры и&nbsp;нажмите «Перевести номенклатуру на&nbsp;новый&nbsp;ИД».
					Старые реквизиты для&nbsp;номенклатуры материалов обычно содержат слово «Material»,
					а&nbsp;для&nbsp;продуктов – «Product».
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-3-3'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px` }}>
					Если вы не произвели вход в Dodo IS до этого, то вам потребуется войти в свою учетную запись.
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-3-4'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px` }}>
					Начнётся загрузка номенклатуры, которая может длиться до&nbsp;нескольких минут. После&nbsp;этого
					откроется таблица сопоставления старой номенклатуры и&nbsp;номенклатуры из&nbsp;Dodo IS.
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-3-5'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px` }}>
					Часть номенклатуры будет сопоставлена автоматически. Если&nbsp;по&nbsp;номенклатуре не&nbsp;нашлось
					сопоставлений, то&nbsp;она&nbsp;будет подсвечена красным. Такие элементы номенклатуры нужно
					сопоставлять вручную. В&nbsp;случае, если&nbsp;вам&nbsp;нужна помощь по&nbsp;переезду со&nbsp;старой
					базы, вы&nbsp;можете{` `}
					<MpLink url={`/${applicationId}#tariffs-details`} text='обратиться за консультацией.' internal />
				</MpText>
			</li>
		</ListStyled>
		<MpPropertyTitle style={{ marginBottom: `16px` }}>Настройка автообмена</MpPropertyTitle>
		<ListStyled>
			<li>
				<MpText>
					Если&nbsp;вам&nbsp;необходим ежедневный обмен на&nbsp;автоматической основе, то&nbsp;во&nbsp;внешние
					обработки добавляем еще&nbsp;одну: «Администрирование» — «Печатные формы, отчеты и&nbsp;обработки» —
					«Дополнительные отчеты и&nbsp;обработки» — «Добавить из&nbsp;файла» и&nbsp;выбрать файл
					«Обмен_DodoIS_ПоРасписанию.epf».
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-12' />
			</li>
			<li>
				<MpText>
					В колонке «Выполнять команду по расписанию» установите галочку, затем откроется окно с расписанием
					запуска.
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-13' />
			</li>
			<li>
				<MpText>На закладке «Общие» укажите «Повторять каждые 1 день».</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-14'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px` }}>
					На второй закладке укажите время запуска обработки. Например, время с 8:00 утра и с 16.00, тогда
					обмен будет запускаться дважды в день, загружаться будут данные за вчерашний день.
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-15'
					style={{ marginBottom: `24px` }}
				/>
				<MpText style={{ marginLeft: `-16px` }}>
					Рекомендуем указывать обмен дважды в день (утренний и вечерний). Документы не будут дублироваться.
					Для файловых баз держите базу 1С открытой.
				</MpText>
			</li>
		</ListStyled>
	</section>
);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DenvikInstruction_eng: FC = () => (
	<section>
		<MpPropertyTitle style={{ marginBottom: `16px` }}>Installation of Processing</MpPropertyTitle>
		<ListStyled>
			<li>
				<MpText>
					Subscribe, and then download the processing using the "Download File" button. The file will be saved
					on your computer.
				</MpText>
			</li>
			<li>
				<MpText>Open 1C and go to the "Administration" menu - "Printed Forms and Processing."</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-1' />
			</li>
			<li>
				<MpText>
					Check that the checkbox is selected for "Additional Reports and Processing." If not, select it.
					Then, follow the link "Additional Reports and Processing."
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-2' />
			</li>
			<li>
				<MpText>Click "Add from File" in the opened list.</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-3' />
			</li>
			<li>
				<MpText>There will be a security warning - click "Continue."</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-4' />
			</li>
			<li>
				<MpText>Select the saved exchange file: DodoIs_DataUpload_Ready.epf.</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-5' />
			</li>
			<li>
				<MpText>
					Choose where in the menu you want to invoke this processing; specify the location, for example,
					sales.
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-6' />
			</li>
			<li>
				<MpText>
					Then specify which user is allowed to use the processing. Go to "Quick Access," move the necessary
					users to the right side of the list in the opened window, and click "OK."
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-7' />
			</li>
			<li>
				<MpText>The processing is added. Click "Save and Close."</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-8' />
			</li>
		</ListStyled>
		<MpPropertyTitle style={{ marginBottom: `16px` }}>Processing Configuration</MpPropertyTitle>
		<ListStyled>
			<li>
				<MpText>
					The exchange processing will be available from the "Sales" menu - "Additional Processes."
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-9' />
			</li>
			<li>
				<MpText>Select the processing "Data Upload (Dodo IS)" and click "Run."</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-10-new' />
			</li>
			<li>
				<MpText>
					In the "Organization" field, select your organization. Then click the "Settings" button.
				</MpText>
			</li>
			<li>
				<MpText>
					When you first open the processing, it will ask you to specify general settings. We recommend using
					the "Fill in all default settings at once" button.
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-11' />
			</li>
			<li>
				<MpText>
					Then click "Get." In the opened window, log in to Dodo IS. After authorization, all data will be
					pulled from Dodo IS.
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-12-new' />
			</li>
		</ListStyled>
		<MpPropertyTitle style={{ marginBottom: `16px` }}>Schedule Configuration</MpPropertyTitle>
		<ListStyled>
			<li>
				<MpText>
					If daily automatic exchange is required, you also need to add another processing to external
					processes: "Administration" - "Additional Reports and Processing" - "Add from File" and select the
					file "Exchange_DodoIS_Scheduled.epf."
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-12' />
			</li>
			<li>
				<MpText>
					In the "Run command on schedule" column, check the box. Then, a window with the launch schedule will
					open.
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-13' />
			</li>
			<li>
				<MpText>On the "General" tab, specify "Repeat every 1 day."</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-14'
					style={{ marginBottom: `24px` }}
				/>
				<MpText>
					On the second tab, specify the processing launch time. For example, the time is 8:00 AM and 4:00 PM.
					Thus, the exchange will run twice a day, loading data from the previous day.
				</MpText>
				<ImgStyled
					src='https://cdn.dodostatic.net/static/marketplace/denvik/instruction-15'
					style={{ marginBottom: `24px` }}
				/>
				<MpText>
					We recommend specifying the exchange twice a day (morning and evening). Documents will not be
					duplicated. For file-based databases, keep the 1C database open.
				</MpText>
			</li>
		</ListStyled>
	</section>
);
